import React, {useState} from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavLogo from '../../media/StewwiLogo.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuOpen from '@mui/icons-material/MenuOpen';
import Badge from '@mui/material/Badge';
import CanvasDrawer from './CanvasDrawer';
import NavbarSearch from './NavbarSearch';
import './NavStyle.css';
import useLogout from '../../hooks/useLogout';
import { useNavigate } from 'react-router-dom';
import BreadcrumbBar from './BreadcrumbBar';
import useAuth from '../../hooks/useAuth';
import { isMobile } from 'react-device-detect';

const RMISNavbar = props => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const logout = useLogout();
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {auth} = useAuth();

  const usersWithNotifications = [
    process.env.REACT_APP_ES_ADMIN,
    process.env.REACT_APP_ES_USER,
    process.env.REACT_APP_CLIENT_ADMIN,
    process.env.REACT_APP_CLIENT_STAFF
  ];

  return (
    <>
      <div className="nav-sticky-stack">
        <Navbar expand="lg" sticky="top" className="rmis-navbar">
          <Container fluid className="rmis-navbar-content d-flex justify-content-between align-items-center">
            <div className="rmis-navbar-left d-flex align-items-center">

              <Nav.Link className="rmis-menu-link" onClick={() => show ? handleClose() : handleShow()}>
                <MenuOpen style={{ 
                    transform: `scaleX(${show ? '' : '-'}1)`, 
                    transformOrigin: 'center', 
                    border:'1px solid lightgrey', 
                    borderRadius:'10%', 
                    boxShadow:'1px 4px 10px lightgrey'
                  }} 
                  className="nav-icon"
                />
              </Nav.Link>

              <a className="navbar-brand rmis-navbar-brand" onClick={() => navigate('/dashboard')} style={{cursor:'pointer'}}>
                <img src={NavLogo} alt="..." height="40" style={{cursor:'pointer'}}/>
              </a>

            </div>
            <div className="d-flex align-items-center">
              {
                usersWithNotifications.includes(auth?.role) &&
                <Nav.Link onClick={() => navigate('/alerts')} style={{marginRight: '2vw'}}>
                  <Badge badgeContent={props.unreadAlerts} color="error">
                    <NotificationsIcon className="nav-icon"/>
                  </Badge>
                </Nav.Link>
              }

              <NavDropdown
                title={<AccountCircleIcon className="nav-icon"/>}
                id="collasible-nav-dropdown"
                align="end"
              >
                {
                  !isMobile && 
                  <>
                  <NavDropdown.Item onClick={() => navigate('/profile')} className="text-muted-dark">Profile</NavDropdown.Item>
                  {
                    usersWithNotifications.includes(auth?.role) &&
                    <>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={() => navigate('/user-accounts')} className="text-muted-dark">User Accounts</NavDropdown.Item>
                    </>
                  }
                  <NavDropdown.Divider />
                  </>
                }
                <NavDropdown.Item
                  className="text-muted-dark"
                  onClick={async () => {
                    await logout();
                    navigate('/');
                  }}
                >
                  Log out
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </Container>
        </Navbar>

        <div className="breadcrumb-wrapper">
          <BreadcrumbBar currentPath={props.currentPath}/>
        </div>
      </div>

      <Offcanvas show={show} placement="start" onHide={handleClose}>
        <CanvasDrawer handleClose={handleClose}/>
      </Offcanvas>
    </>
  );
}

export default RMISNavbar;
